<template>
  <lazy-render render-on-idle>
    <Transition name="translate-y-bottom">
      <div
        v-if="show"
        class="bundle-summary-toggle fixed bottom-0 left-0 right-0 w-full z-20"
        @click="showBundleSummary"
      >
        <div
          class="flex flex-col gap-2 bg-white px-4 py-2 shadow-top"
        >

          <div v-if="validSize && hasReferral" class="text-center text-blue-500 font-semibold w-full text-sm">
            Referral Discount Applied!
          </div>

          <button
            class="button +green +large text-base! flex items-center justify-center w-full"
            :class="!validSize && 'disabled'"
          >
            <span
              v-if="totalQuantity < bundleStore.MIN_SIZE"
              class="pr-12"
            >
              {{ $bt('min_size_prompt', bundleType, { minSize: bundleStore.MIN_SIZE }) }}
            </span>
            <span
              v-else-if="totalQuantity === bundleStore.MIN_SIZE"
              class="pr-4"
              v-html="$t('bundler.review_or_add')"
            />
            <span
              v-else-if="totalQuantity > bundleStore.MIN_SIZE && totalQuantity < bundleStore.MAX_SIZE"
              class="pr-5"
            >
              {{ $bt('choose_valid_size', bundleType) }}
            </span>
            <span
              v-else-if="quantityAtMaximum"
              class="text-xl leading-5 pr-12"
            >
              {{ $t('bundler.review_your_box') }}
            </span>
            <div
              class="rounded-[56px] absolute right-3 text-sm p-1 w-[56px]"
              :class="validSize ? 'bg-green-600' : 'bg-neutral-500'"
            >
              <span v-if="validSize">
                {{ totalQuantity }}
              </span>
              <span v-else>
                {{ totalQuantity }}/{{ size }}
              </span>
            </div>
          </button>
          <BundleMiniCallouts />
        </div>
      </div>
    </Transition>
  </lazy-render>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'
import { useBundleStore, useThemeStore, useReferralStore } from '@/stores'
import { showBundleSummary } from '@/utils/bundle'
import BundleMiniCallouts from './bundle-mini-callouts.vue'

const SCROLL_LIMIT = 140

const { sheet } = useThemeStore()
const bundleStore = useBundleStore()
const referralStore = useReferralStore()
const { bundleType } = bundleStore // bundleType is not a ref, just a variable
const { ready, validSize, quantityAtMaximum, totalQuantity, size } = storeToRefs(bundleStore)
const { hasReferral } = storeToRefs(referralStore)
const scrolled = ref(window.scrollY > SCROLL_LIMIT)
const show = computed(() => ready.value && totalQuantity.value)

const handleSwipe = (e) => {
  if (e.target?.closest('.bundle-summary-toggle')) {
    showBundleSummary()
  }
}

const handleScroll = () => {
  if (window.scrollY > 200) {
    window.removeEventListener('scroll', handleScroll)
    scrolled.value = true
  }
}

onMounted(() => {
  document.getElementById('shopify-section-layout-footer')?.classList?.add('pb-20')
  document.addEventListener('swiped-up', handleSwipe)
  if (!(scrolled.value || totalQuantity.value)) {
    window.addEventListener('scroll', handleScroll)
  }
})

onBeforeUnmount(() => {
  document.getElementById('shopify-section-layout-footer')?.classList?.remove('pb-20')
  document.removeEventListener('swiped-up', handleSwipe)
  window.removeEventListener('scroll', handleScroll)
  sheet.close()
})
</script>
